<template>
  <CheckboxGroup v-model="item.value">
    <Checkbox v-for="o in (item.checks || [])" :key="o.value" border :label="o.value">{{o.text}}</Checkbox>
  </CheckboxGroup>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-checkbox',
  mixins: [props],
  data () {
    return {}
  }
}
</script>